class MathUtils {
  static ensureFiniteNumber(numberCandidate, labelText) {
    if (!Number.isFinite(numberCandidate)) throw new TypeError(`MathUtils expected ${labelText} to be a finite number`);
    return numberCandidate;
  }

  static add(leftOperand, rightOperand) {
    MathUtils.ensureFiniteNumber(leftOperand, "leftOperand");
    MathUtils.ensureFiniteNumber(rightOperand, "rightOperand");
    return leftOperand + rightOperand;
  }

  static subtract(leftOperand, rightOperand) {
    MathUtils.ensureFiniteNumber(leftOperand, "leftOperand");
    MathUtils.ensureFiniteNumber(rightOperand, "rightOperand");
    return leftOperand - rightOperand;
  }

  static multiply(leftOperand, rightOperand) {
    MathUtils.ensureFiniteNumber(leftOperand, "leftOperand");
    MathUtils.ensureFiniteNumber(rightOperand, "rightOperand");
    return leftOperand * rightOperand;
  }

  static divide(dividendValue, divisorValue) {
    MathUtils.ensureFiniteNumber(dividendValue, "dividendValue");
    MathUtils.ensureFiniteNumber(divisorValue, "divisorValue");
    if (divisorValue === 0) throw new RangeError("MathUtils cannot divide by zero");
    return dividendValue / divisorValue;
  }
}

export { MathUtils };
